<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="dialogPartidas.estatus"
    persistent
    max-width="1000"
  >
    <v-card>
    	<v-card-title primary-title>
    	  Multiples partidas
    	</v-card-title>
    	<v-card-text>

    		<upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" class="mr-2"/>
        <p class="caption grey--text text-left mt-2 mb-0">
          Columna de fecha: use <code>fecha_propuesta</code> o el encabezado <code>Fecha propuesta</code> (AAAA-MM-DD o celda con formato fecha en Excel).
        </p>

        <v-data-table
        	v-if="verTabla"
			    :headers="headers"
			    :items="detalles"
			    dense
			    class="elevation-0 mt-4"
			  >

			    <template v-slot:item.fecha_propuesta="{ item }">
			      <span>{{ item.fecha_propuesta ? String(item.fecha_propuesta).slice(0, 10) : '—' }}</span>
			    </template>

			    <template v-slot:item.id_plantel="{ item }">
			      <span>{{ planteles.find( el=> el.id_plantel == item.id_plantel ).plantel }}</span>
			    </template>

			    <template v-slot:item.id_elemento_requisicion="{ item }">
			      <span>{{ elementos.find( el=> el.id_elemento_mantenimiento == item.id_elemento_requisicion ).elemento_mantenimiento }}</span>
			    </template>

			  </v-data-table>

    	</v-card-text>

    	<v-card-actions>

		    <v-btn tile dark small @click="dialogPartidas.estatus = false" color="black">
		    	<v-icon small left >mdi-close</v-icon>
		    	cancelar
		    </v-btn>

		    <v-spacer></v-spacer>

		    <v-btn tile dark small @click="$emit('cargarPartidaMultiple', detalles)" color="primary" v-if="detalles.length">
		    	<v-icon small left >mdi-upload</v-icon>
		    	Cargar
		    </v-btn>

    	</v-card-actions>
    </v-card>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>


<script>
import axios from 'axios';

	import { mapGetters } from 'vuex'


	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores       from '@/mixins/validarErrores'
  import UploadExcelComponent from '@/components/UploadExcel.vue'


	export default {
		props:[
			'dialogPartidas'
	  ],

  	components:{
      Alerta,
      carga,
      UploadExcelComponent
    },

    mixins: [ validarErrores ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'Elemento Compra' , value: 'id_elemento_requisicion' },
        { text: 'Concepto'        , value: 'concepto'                },
        { text: 'Fecha propuesta' , value: 'fecha_propuesta' },
        { text: 'Plantel'         , value: 'id_plantel'              },
        { text: 'Cantidad'        , value: 'cantidad'                },
        { text: 'Costo Unit.'     , value: 'costo_unitario'          },
        { text: 'Total'           , value: 'costo_total'             },
        { text: 'Actions'         , value: 'actions', sortable: false },
      ],

      ciclos: [],
      ciclo: null,
      comentarios:'',

      opVisualizacion: 1,

      editedIndex: -1,

      editedItem: {
        id_elemento_requisicion: 0, 
		    id_plantel:              0, 
		    concepto:                '', 
		    cantidad:                0, 
		    costo_unitario:          0,
		    costo_total:             0,
		    id_empleado:             0, 
    		detalles:[]
      },

      defaultItem: {
        id_elemento_requisicion: 0, 
		    id_plantel:              0, 
		    concepto:                '', 
		    cantidad:                0, 
		    costo_unitario:          0,
		    costo_total:             0,
		    id_empleado:             0, 
    		detalles:[]
      },

      detalles:[],
      empleados:[],
      elementos:[],
      planteles:[],
      verTabla: true,

      id_usuario_solicita:'',
      id_sucursal_solicita:'',
      id_requisicion_compra_estatus:'',
      id_usuario_ultimo_cambio:'',

      id_usuario_compra: 28,
      tipo_requisicion:1,
      id_ciclo:0,
      comentarios:'',
      idrequisicion_compra : null,
      elementos:[],
      planteles:[],

    }),

    computed: {
    	...mapGetters('login', ['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
    },

    async created () {
    	await this.getPlanteles()
      await this.getElementosCompras()
    },

    methods: {

    	getPlanteles () {
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getElementosCompras () {
        this.elementos = []
        return this.$http.get('consultar.elemtos.compra').then(response=>{
        	this.elementos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      beforeUpload(file) {
	      const isLt1M = file.size / 1024 / 1024 < 1
	      if (isLt1M) {
	        return true
	      }
	      this.$message({
	        message: 'Please do not upload files larger than 1m in size.',
	        type: 'warning'
	      })

	      return false
	    },

	    handleSuccess({results, header }) {
	      this.obtenerDatos(results);
	    },

	    obtenerDatos (results){
	      const Temporal = results.map((value) => this.normalizarFilaDesdeExcel(value))
	      this.detalles = Temporal
	    },

      /** Encabezados típicos de Excel (espacios, mayúsculas) → valor crudo de fecha */
      obtenerFechaPropuestaCruda(row) {
        if (!row || typeof row !== 'object') return undefined
        const keys = [
          'fecha_propuesta',
          'Fecha propuesta',
          'FECHA_PROPUESTA',
          'Fecha_propuesta',
          'fecha propuesta',
        ]
        for (const k of keys) {
          if (Object.prototype.hasOwnProperty.call(row, k)) {
            const v = row[k]
            if (v !== undefined && v !== null && String(v).trim() !== '') return v
          }
        }
        return undefined
      },

      /** Serial Excel → YYYY-MM-DD (misma convención que el backend). */
      fechaExcelSerialAISO(serial) {
        if (typeof serial !== 'number' || Number.isNaN(serial) || serial <= 20000 || serial >= 120000) return ''
        const utc = Math.round((serial - 25569) * 86400 * 1000)
        const d = new Date(utc)
        if (Number.isNaN(d.getTime())) return ''
        return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`
      },

      normalizarFechaPropuestaDesdeExcel(val) {
        if (val === undefined || val === null) return ''
        if (typeof val === 'number' && !Number.isNaN(val)) {
          const fromSerial = this.fechaExcelSerialAISO(val)
          if (fromSerial) return fromSerial
        }
        if (val instanceof Date && !Number.isNaN(val.getTime())) {
          return `${val.getFullYear()}-${String(val.getMonth() + 1).padStart(2, '0')}-${String(val.getDate()).padStart(2, '0')}`
        }
        const s = String(val).trim()
        if (!s) return ''
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
        const d = new Date(s)
        if (!Number.isNaN(d.getTime())) {
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        }
        return ''
      },

      normalizarFilaDesdeExcel(value) {
        const row = { ...value }
        if (row.id_elemento_requisicion != null) {
          row.id_elemento_requisicion = row.id_elemento_requisicion
        }
        if (row.id_plantel != null) {
          row.id_plantel = row.id_plantel
        }
        if (row.concepto != null) {
          row.concepto = row.concepto
        }
        if (row.cantidad != null) {
          row.cantidad = row.cantidad
        }
        if (row.costo_unitario != null) {
          row.costo_unitario = row.costo_unitario
        }
        if (row.costo_total != null) {
          row.costo_total = row.costo_total
        }
        const fpCruda = this.obtenerFechaPropuestaCruda(row)
        row.fecha_propuesta = this.normalizarFechaPropuestaDesdeExcel(fpCruda)
        row.id_empleado = 0
        return row
      },

    },
  }
</script>